import axios from '../../../config/axios';
import { BASE_URL_API } from '../../../config/env';
import useQuery2 from '../../../hooks/useQuery2';

const getRegions = () =>
  axios({
    method: 'GET',
    url: `${BASE_URL_API}/api/v1/regions`
  }).then(({ data }) => data)

export const getRegionsHelper = {
  queryKey: ['app-public.regions'],
  queryFn: () => getRegions(),
  isArray: true
}

export const useGetRegions = () => {
  return useQuery2({
    queryKey: ['app-public.regions'],
    queryFn: () => getRegions()
  });
};
